import { useGame } from "../store";

/** Shows a disclosed clue (from the clue_disclosed event) as a dismissible card. */
export function ClueModal(): React.ReactElement | null {
  const clueText = useGame((s) => s.clueText);
  const setClue = useGame((s) => s.setClue);
  if (!clueText) return null;

  return (
    <div className="overlay" onClick={() => setClue(null)}>
      <div className="clue-card" onClick={(e) => e.stopPropagation()}>
        {/* Clue text is authored show content, rendered as HTML like the legacy dialog. */}
        <div dangerouslySetInnerHTML={{ __html: clueText }} />
        <button onClick={() => setClue(null)}>Got it</button>
      </div>
    </div>
  );
}
